import {Html5Entities} from 'html-entities';

/**
 * Html Entity Encode/Decode Utils
 *
 encode('<>"\'&©®')); // &lt;&gt;&quot;&apos;&amp;©®
 encodeNonUTF('<>"\'&©®')); // &lt;&gt;&quot;&apos;&amp;&#169;&#174;
 encodeNonASCII('<>"\'&©®')); // <>"\'&©®
 decode('&lt;&gt;&quot;&apos;&amp;&copy;&reg;&#8710;')); // <>"'&&copy;&reg;∆
 *
 */
const entities = new Html5Entities();

export function htmlEntitiesEncode(s) {
    return entities.encode(s);
}

export function htmlEntitiesDecode(s) {
    return entities.decode(s);
}
